// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.boostads.RentalManagerUserPropertyBoostAdsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  BoostAdConfigDetailsDto,
  BoostAdFlagType,
  ListingAlias,
  RentalManagerUpdateBoostListingDetailsRequestDto,
} from '../..';

interface GetBoostListingDetailsParams {
  customerId: string;
  listingAlias: ListingAlias;
}
interface GetListingHousingFlagTypesParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Path =
  '/api/web/v1/users/properties/boostAds/getBoostListingDetails';

/**
 * Get boost ad config by listing alias
 */
export const RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails = (
  getParams: GetBoostListingDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetBoostListingDetailsParams, never, BoostAdConfigDetailsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyBoostAdsWebApiHandler_getBoostListingDetails_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Path =
  '/api/web/v1/users/properties/boostAds/getListingHousingFlagTypes';

/**
 * Get Listing Housing Flag Types
 */
export const RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes = (
  getParams: GetListingHousingFlagTypesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetListingHousingFlagTypesParams, never, Array<BoostAdFlagType>>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyBoostAdsWebApiHandler_getListingHousingFlagTypes_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Path =
  '/api/web/v1/users/properties/boostAds/updateBoostListingDetails';

/**
 * Update boost ad for listing
 */
export const RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails = (
  postData: RentalManagerUpdateBoostListingDetailsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerUpdateBoostListingDetailsRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyBoostAdsWebApiHandler_updateBoostListingDetails_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
